// GFT and ULA tables share a groupId. After any module in a table is removed,
// the rest of that table is removed too. Keep this free of store.getState()
// so REMOVE_PANELS can run it inside the reducer.
export function dropEntireTablesForRemovedPanels(
  panels: panelInState[],
  ids: number[],
): panelInState[] {
  const removed = new Set(ids);
  const groupIdsToRemove = new Set<number>();
  panels.forEach((panel) => {
    if (removed.has(panel.id)) {
      groupIdsToRemove.add(panel.groupId);
    }
  });
  if (groupIdsToRemove.size === 0) {
    return panels.filter(panel => !removed.has(panel.id));
  }
  return panels.filter(panel => !groupIdsToRemove.has(panel.groupId));
}

// SM Ascender on develop deletes by pairId (the 2P column pair), not the
// whole table. Same constraint: no store.getState() in the reducer.
export function dropPanelsByPairId(
  panels: panelInState[],
  ids: number[],
): panelInState[] {
  const removed = new Set(ids);
  const pairIdsToRemove = new Set<number>();
  panels.forEach((panel) => {
    if (removed.has(panel.id) && panel.pairId != null) {
      pairIdsToRemove.add(panel.pairId);
    }
  });
  if (pairIdsToRemove.size === 0) {
    return panels.filter(panel => !removed.has(panel.id));
  }
  return panels.filter(panel => !pairIdsToRemove.has(panel.pairId));
}
